import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { CouponGroup, CouponGroupDetail } from './couponGroup.types';

export const useGetCouponGroups = () => {
  return useQuery<AxiosResponse<CouponGroup[]>>({
    queryKey: ['getCouponGroups'],
    queryFn: () => apiClient.get<CouponGroup[]>('/coupon-groups')
  });
};

export const useGetCouponGroup = (
    couponGroupId: string,
    enabled: boolean = true
) => {
  return useQuery<AxiosResponse<CouponGroup>>({
    queryKey: ['getCouponGroup', couponGroupId],
    queryFn: () => apiClient.get<CouponGroup>(`/coupon-groups/${couponGroupId}`),
    enabled: enabled
  })
}

export const useGetCouponGroupDetails = (
    couponGroupId: string,
    enabled: boolean = true
) => {
  return useQuery<AxiosResponse<CouponGroupDetail[]>>({
    queryKey: ['getCouponGroupDetails', couponGroupId],
    queryFn: () => apiClient.get<CouponGroupDetail[]>(`/coupon-groups/${couponGroupId}/details`),
    enabled: enabled
  })
}
